// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangePassword_wrapper__EeLfZ","inputSpace":"ChangePassword_inputSpace__H+BDI","buttonToRight":"ChangePassword_buttonToRight__hzGtV"};